export const MasterFoodTableColumns = [
    {
      id: "S.No",
      label: "S.No",
      minWidth: 70,
      align: "left",
    },
    {
      id: "patientName",
      label: "Name",
      minWidth: 200,
      align: "left",
    },
    {
      id: "image",
      label: "Image",
      minWidth: 120,
      align: "center",
      type: "image",
    },
    {
      id: "coreCategory",
      label: "Core Category",
      minWidth: 150,
      align: "center",
    },
    {
      id: "category",
      label: "Category",
      minWidth: 150,
      align: "center",
    },
    {
      id: "subCategory",
      label: "Sub Category",
      minWidth: 150,
      align: "center",
    },
    {
      id: "fodmap",
      label: "FODMAP Level",
      minWidth: 120,
      align: "center",
    },
    {
      id: "calories",
      label: "Calories",
      minWidth: 100,
      align: "left",
    },
    {
      id: "carbs",
      label: "Carbs",
      minWidth: 100,
      align: "left",
    },
    {
      id: "fat",
      label: "Fat",
      minWidth: 100,
      align: "left",
    },
    {
      id: "fiber",
      label: "Fiber",
      minWidth: 100,
      align: "left",
    },
    {
      id: "protein",
      label: "Protein",
      minWidth: 100,
      align: "left",
    },
    {
      id: "createdAt",
      label: "Created At",
      minWidth: 150,
      align: "center",
    },
    {
      id: "updatedAt",
      label: "Updated At",
      minWidth: 150,
      align: "center",
    },
    {
        id: "details",
        label: "Recipe",
        minWidth: 70,
        align: "center",
    },
    // {
    //     id: "active",
    //     label: "Active",
    //     minWidth: 70,
    //     align: "center",
    //   },
      {
        id: "action",
        label: "Action",
        minWidth: 100,
        align: "center",
      },
  ];
  